import React from 'react';

export const ExternalLink = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<g fillRule="evenodd" stroke="none" strokeWidth="1">
			<path d="M13 4v2H6a1 1 0 00-1 1v11a1 1 0 001 1h12a1 1 0 001-1v-6h2v6a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7zm8.311-.67a.607.607 0 01.448.19c.127.126.19.276.19.45v5.113a.618.618 0 01-.189.45.619.619 0 01-.45.19.611.611 0 01-.449-.19l-1.759-1.759-6.511 6.512a.314.314 0 01-.458 0l-1.138-1.138a.315.315 0 010-.459l6.511-6.511-1.759-1.759a.614.614 0 01-.19-.448c0-.173.063-.324.19-.45a.62.62 0 01.45-.19h5.114z" />
		</g>
	</svg>
);
